import { OtherUser } from "../../types";
import { PersonComment } from "./PersonComment";

type Props = {
    screenWidth: number;
    comment: string | React.ReactNode;
    targetUser: OtherUser;
    imageSrc: string;
    isMyself: boolean;
};
export function PcContent({
    comment,
    targetUser,
    imageSrc,
    isMyself,
    screenWidth,
}: Props) {
    return (
        <PersonComment
            targetUser={targetUser}
            imageSrc={imageSrc}
            screenWidth={screenWidth}
            comment={comment}
            isMyself={isMyself}
        />
    );
}
